import PropTypes from "prop-types";
import Button from "../Button/Button";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const Modal = (props) => {
  const { isOpen, closeBtn, sizeClass="medium", hideCloseButton, isNonClosable, style } = props;
  let className = sizeClass + `-modal modal ${isNonClosable ? "non-closable-modal" : ""}`;
  if (isOpen) {
    return (
      <div onClick={props.handleClick} className={props.className}>
        <div className="overlay" onClick={closeBtn}></div>
        <TransitionGroup>
          <CSSTransition classNames={props.transitionName} timeout={{ enter: 500, exit: 300 }}>
            <div className={className} style={style}>
              {hideCloseButton ? null : (
                <div className={"modal-btn-container"}>
                  <Button classes={"close-btn close-reveal-modal"} handleClick={closeBtn} text="✕" />
                </div>
              )}
              {props.children}
            </div>
          </CSSTransition>
        </TransitionGroup>
        <style jsx>{`
          .modal-anim-enter {
            opacity: 0;
            transform: scale(0.7);
            transition: all 0.2s;
          }

          .modal-anim-enter.modal-anim-enter-active {
            opacity: 1;
            transform: scale(1);
          }

          .modal-anim-exit {
            opacity: 1;
            transform: scale(1);
            transition: all 0.2s;
          }

          .modal-anim-exit.modal-anim-exit-active {
            opacity: 0;
            transform: scale(0.7);
          }

          .modal {
            width: 55%;
            z-index: 99999;
            border: 1px solid #00000080;
            background: white;
            position: fixed;
            top: 50%;
            left: 50%;
            padding: 10px;
            transform: translate(-50%, -50%);
          }
          .autoPopUp .modal {
            top: 70%;
          }
          .modal .modal-body {
            height: 100%;
          }
          .overlay {
            background: #00000080;
            bottom: 0;
            left: 0;
            position: fixed;
            right: 0;
            top: 0;
            z-index: 99998;
            pointer-events: none;
          }

          .tiny-modal {
            width: 25%;
          }
          .long-modal {
            width: 28%;
            top: 50%;
            max-width: 380px;
          }

          .small-modal {
            width: 80%;
          }

          .medium-modal {
            width: 55%;
          }

          .large-modal {
            width: 70%;
          }

          .xlarge-modal {
            width: 85%;
          }

          .full-modal {
            width: 100%;
            height: 100%;
            top: 0;
          }

          .modal button.close-btn {
            background: transparent;
            color: #000;
            border: 0;
            float: right;
            font-size: 24px;
            width: auto;
            padding: 0;
            cursor: pointer;
            outline: 0;
            cursor: pointer;
            outline: none;
          }

          @media (max-width: 575px) {
            .modal {
              transform: translate(-50%, -35%);
            }
            @media (max-width: 575px) {
              .dealspage__overlay .modal {
                transform: translate(-50%, -48%);
              }
              .autoPopUp .modal.non-closable-modal {
                top: 50%;
              }
            }
            .medium-modal,
            .small-modal,
            .medium-modal,
            .large-modal,
            .xlarge-modal,
            .full-modal,
            .tiny-modal,
            .long-modal {
              width: 90%;
            }
            .autoPopUp .modal {
              top: 70%;
            }
            .long-modal {
              top: 35%;
              max-height: 90%;
              overflow: auto;
              max-width: 450px;
            }
          }
          @media only screen and (min-width: 375px) and (max-width: 896px) and (orientation: landscape) {
            .long-modal {
              width: 45%;
              max-width: 450px;
              height: 90%;
              bottom: 0;
              overflow: auto;
            }
          }
          @media (min-width: 575px) and (max-width: 786px) {
            .long-modal {
              width: 45%;
            }
          }
          @media (min-width: 768px) and (max-width: 1024px) {
            .long-modal {
              width: 45%;
              max-width: 380px;
            }
          }
          @media (min-width: 1025px) {
            .small-modal {
              width: 50%;
            }
            .autoPopUp .modal {
              top: 55%;
            }
          }
          @media (min-width: 1024px) {
            .autoPopUp .modal {
              top: 55%;
            }
            .autoPopUp .modal.non-closable-modal {
              top: 50%;
            }
          }
          @media (min-width: 768px) and (max-width: 1023px) {
            .autoPopUp .modal {
              top: 75%;
            }
            .autoPopUp .modal.non-closable-modal {
              top: 50%;
            }
            .small-modal {
              width: 85%;
            }
          }
        `}</style>
      </div>
    );
  } else {
    return (
      <TransitionGroup>
        <CSSTransition classNames={props.transitionName} timeout={{ enter: 500, exit: 300 }} ><></></CSSTransition>
      </TransitionGroup>
    );
  }
};

export default Modal;

Modal.propTypes = {
  id: PropTypes.string,
  sizeClass: PropTypes.string, //tiny, small, medium, large, xlarge, full
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  transitionName: PropTypes.string,
  closeBtn: PropTypes.func,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  style: PropTypes.object,
};
